// Central business data — update here and the whole site follows.

export const BUSINESS = {
  name: "Glam Girl Makeup Studio",
  shortName: "Glam Girl",
  category: "Ladies Salon · Hair & Makeup Studio",
  rating: "4.8",
  reviewCount: 56,
  hoursLine: "Open Daily · 10:00 AM – 8:00 PM",
  hoursShort: "10:00 AM – 8:00 PM",
  address:
    "Patel Nagar Chauraha, in front of G.D. Goenika School, Varanasi, Hardattpur, Uttar Pradesh 221311",
  area: "Patel Nagar / Hardattpur, Varanasi",
  phoneDisplay: "+91 63923 32169",
  phoneTel: "tel:+916392332169",
  whatsappDisplay: "+91 96215 72169",
  whatsappNumber: "919621572169",
  instagram: "https://www.instagram.com/glamgirl_makeupstudio1?stkn=bDRhcjUycDRnM3Fw",
  instagramHandle: "@glamgirl_makeupstudio1",
  mapsUrl: "https://share.google/esTTXTOmFyreYHFqd",
  mapsEmbed:
    "https://www.google.com/maps?q=Glam+Girl+Makeup+Studio,+Patel+Nagar+Chauraha,+Hardattpur,+Varanasi,+Uttar+Pradesh+221311&output=embed",
};

export const waLink = (message) =>
  `https://wa.me/${BUSINESS.whatsappNumber}?text=${encodeURIComponent(message)}`;

export const waServiceLink = (service) =>
  waLink(`Hello Glam Girl Makeup Studio, I would like to enquire about ${service}.`);

export const WA_DEFAULT = waLink(
  "Hello Glam Girl Makeup Studio, I would like to enquire about an appointment."
);

export const IMAGES = {
  bridalDoor: {
    src: "/images/bridal-door.jpg",
    alt: "Bride in a red lehenga at the entrance of Glam Girl Makeup Studio, Varanasi",
  },
  bridalMirror: {
    src: "/images/bridal-mirror.jpg",
    alt: "Bride in a red lehenga seated at the studio's LED arch mirror",
  },
  bridalPortrait: {
    src: "/images/bridal-portrait.jpg",
    alt: "Bridal makeup and styling by Glam Girl Makeup Studio, Varanasi",
  },
  salonInterior: {
    src: "/images/salon-interior.jpg",
    alt: "Inside Glam Girl Makeup Studio — LED arch mirrors and styling stations",
  },
  logo: {
    src: "/images/logo.jpg",
    alt: "Glam Girl Makeup Studio logo",
  },
};

export const SERVICES = [
  {
    id: "hair",
    name: "Hair",
    tagline: "Haircut, styling, blowdry, curly styling and more.",
    items: [
      "Haircut",
      "Hairstyling",
      "Blowdry",
      "Curly Hair Styling",
      "Perms",
      "Children's Cuts",
      "Shampoo & Conditioning",
    ],
  },
  {
    id: "hair-colour",
    name: "Hair Colour",
    tagline: "Colouring, highlights and ombre hair colour.",
    items: ["Hair Colouring", "Hair Highlighting", "Ombre Hair Colour"],
  },
  {
    id: "hair-treatments",
    name: "Hair Treatments",
    tagline: "Keratin, treatments and hair straightening.",
    items: ["Keratin Treatments", "Hair Treatments", "Hair Straightening"],
  },
  {
    id: "braiding",
    name: "Braiding",
    tagline: "Braids and box braids.",
    items: ["Braids", "Box Braids"],
  },
  {
    id: "waxing-shaving",
    name: "Waxing & Shaving",
    tagline: "Body waxing and shaving.",
    items: ["Body Waxing", "Shaving"],
  },
  {
    id: "makeup",
    name: "Makeup",
    tagline: "Make-up services.",
    items: ["Make-up Services"],
  },
  {
    id: "bridal-occasion",
    name: "Bridal & Occasion",
    tagline: "Bridal hair and bridal services.",
    items: ["Bridal Hair", "Bridal Services"],
  },
];

export const ALL_SERVICES = SERVICES.flatMap((c) => c.items);

export const REVIEWS = [
  { name: "Dr. Ananya Sharma", text: "Professional service, hygienic environment and a very comfortable experience." },
  { name: "Dr. Riya Singh", text: "Excellent service and attention to detail. Highly recommended." },
  { name: "Medical Student", text: "Very neat, professional and friendly service. Loved the overall experience." },
  { name: "Medical Student", text: "The staff was polite and the service was handled very professionally." },
  { name: "Dr. Priya Verma", text: "Beautiful ambience, professional team and excellent service quality." },
  { name: "Medical Student", text: "A clean and relaxing place with genuinely good service." },
  { name: "Dr. Neha Gupta", text: "Great attention to detail and a smooth, comfortable experience." },
  { name: "Medical Student", text: "Professional, hygienic and welcoming. Definitely a great salon experience." },
  { name: "Dr. Mehak Kapoor", text: "Loved the professionalism and personalised attention throughout the service." },
  { name: "Medical Student", text: "Excellent experience from start to finish. The team was very courteous." },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/bridal-makeup", label: "Bridal & Makeup" },
  { to: "/about", label: "About" },
  { to: "/gallery", label: "Gallery" },
  { to: "/visit", label: "Visit Us" },
];
